module.exports = __webpack_public_path__ + "static/media/202.73808804.webp";